import { render, staticRenderFns } from "./DialogBank.vue?vue&type=template&id=502c8196"
import script from "./DialogBank.vue?vue&type=script&lang=js"
export * from "./DialogBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports